
import dialogDashboard from "@/views/dashboard/top/dialog/dialog.vue";
import VueApexCharts from "vue-apexcharts";
import {
    getTopreportTopbuy,
    getTopreportTopviewlive,
    getTopreportTopuserview,
} from "@/service/dashboard/dashboard";
export default {
    props: {
        sendDataGroupSelect: {
            type: Array,
        },
        isOpenTopUserView: {
            type: Boolean
        },
        closeDialogTopUserView: {
            type: Function,
        },

        isOpenBuyUser: {
            type: Boolean
        },
        closeDialogBuyUser: {
            type: Function,
        },

        isOpenViewLive: {
            type: Boolean
        },
        closeDialogViewLive: {
            type: Function,
        },
        dataIsGroupNull: {
            type: Boolean,
            default: false,
        }

    },
    components: {
        apexchart: VueApexCharts,
        dialogDashboard,
    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
            loaddata: false,
            dataGroup: [],
            topUserViewCourseDialog: [],
            pageTopUser: 1,
            limitTopUser: 10,
            pageCountTopUser: 1,

            buyUserDialog: [],
            pageBuyUser: 1,
            limitBuyUser: 10,
            pageCountBuyUser: 1,

            viewLiveDialog: [],
            pageViewLive: 1,
            limitViewLive: 10,
            pageCountViewLive: 1
        }
    },
    watch: {
        sendDataGroupSelect(value) {
            this.dataGroup = value
            // console.log("dialog", this.dataGroup)
            // this.setTable()
        },
        isOpenTopUserView(value) {
            this.buyUserDialog = []
            this.pageTopUser = 1
            this.limitTopUser = 10
            this.pageCountTopUser = 1

            if (value) {
                console.log("TopUserView", this.dataGroup)
                this.setTableTopUser()
            }
        },
        isOpenBuyUser(value) {
            this.buyUserDialog = []
            this.pageBuyUser = 1
            this.limitBuyUser = 10
            this.pageCountBuyUser = 1
            if (value) {
                console.log("BuyUser", this.dataGroup)
                this.setTableBuyUser()
            }
        },
        isOpenViewLive(value) {
            this.viewLiveDialog = []
            this.pageViewLive = 1
            this.limitViewLive = 10
            this.pageCountViewLive = 1
            if (value) {
                console.log("ViewLive", this.dataGroup)
                this.setTableViewLive()
            }
        }


    },
    methods: {
        async setTableTopUser() {
            this.loaddata = true
            let params = {
                page: this.pageTopUser,
                limit: this.limitTopUser,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultTopreport = await getTopreportTopuserview(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultTopreport.data.length; index++) {
                if (resultTopreport) {

                    if (resultTopreport.data[index]) {
                        topUserViewCourse.push(resultTopreport.data[index])
                    } else {
                        topUserViewCourse.push({ firstName: '', lastName: '' })
                    }
                }

            }
            this.loaddata = topUserViewCourse ? false : true
            this.pageCountTopUser = resultTopreport.maxPage
            this.topUserViewCourseDialog = topUserViewCourse
        },
        async changePageTopUser() {
            this.loaddata = true
            let params = {
                page: this.pageTopUser,
                limit: this.limitTopUser,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultTopreport = await getTopreportTopuserview(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultTopreport.data.length; index++) {
                if (resultTopreport) {

                    if (resultTopreport.data[index]) {
                        topUserViewCourse.push(resultTopreport.data[index])
                    } else {
                        topUserViewCourse.push({ firstName: '', lastName: '' })
                    }
                }

            }
            this.loaddata = resultTopreport ? false : true
            this.pageCountTopUser = resultTopreport.maxPage
            this.topUserViewCourseDialog = topUserViewCourse
        },

        async setTableBuyUser() {
            this.loaddata = true
            let params = {
                page: this.pageBuyUser,
                limit: this.limitBuyUser,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultBuyUser = await getTopreportTopbuy(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultBuyUser.data.length; index++) {
                if (resultBuyUser) {

                    if (resultBuyUser.data[index]) {
                        topUserViewCourse.push(resultBuyUser.data[index])
                    } else {
                        topUserViewCourse.push({})
                    }
                }

            }
            this.loaddata = topUserViewCourse ? false : true
            this.pageCountBuyUser = resultBuyUser.maxPage
            this.buyUserDialog = topUserViewCourse
        },
        async changePageBuyUser() {
            this.loaddata = true
            let params = {
                page: this.pageBuyUser,
                limit: this.limitBuyUser,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultBuyUser = await getTopreportTopbuy(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultBuyUser.data.length; index++) {
                if (resultBuyUser) {

                    if (resultBuyUser.data[index]) {
                        topUserViewCourse.push(resultBuyUser.data[index])
                    } else {
                        topUserViewCourse.push({})
                    }
                }

            }
            this.loaddata = topUserViewCourse ? false : true
            this.pageCountBuyUser = resultBuyUser.maxPage
            this.buyUserDialog = topUserViewCourse
        },

        async setTableViewLive() {
            this.loaddata = true
            let params = {
                page: this.pageViewLive,
                limit: this.limitViewLive,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultViewLive = await getTopreportTopviewlive(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultViewLive.data.length; index++) {
                if (resultViewLive) {

                    if (resultViewLive.data[index]) {
                        topUserViewCourse.push(resultViewLive.data[index])
                    } else {
                        topUserViewCourse.push({})
                    }
                }

            }
            this.loaddata = topUserViewCourse ? false : true
            this.pageCountViewLive = resultViewLive.maxPage
            this.viewLiveDialog = topUserViewCourse
        },
        async changePageViewLive() {
            this.loaddata = true
            let params = {
                page: this.pageViewLive,
                limit: this.limitViewLive,
                usergroup: this.dataGroup,
                groupnull: this.dataIsGroupNull,
            }
            let resultViewLive = await getTopreportTopviewlive(params)
            let topUserViewCourse = []
            for (let index = 0; index < resultViewLive.data.length; index++) {
                if (resultViewLive) {

                    if (resultViewLive.data[index]) {
                        topUserViewCourse.push(resultViewLive.data[index])
                    } else {
                        topUserViewCourse.push({})
                    }
                }

            }
            this.loaddata = topUserViewCourse ? false : true
            this.pageCountViewLive = resultViewLive.maxPage
            this.viewLiveDialog = topUserViewCourse
        }

    }
}